module.exports = __webpack_public_path__ + "img/course108_summary_unit_timelines.486483a9.png";